export const TutorReviews = [
  {
    reviewTitle: " Very Organised",
    location: "Bangalore,India",
    name: "Geetha Sridhara",
    image: "customer-review-1.png",
    content:
      "	I got to know about HomeShiksha from a parent and I thought of giving a try for my kid’s tuition. It’s very organised and they gave 3 teachers for demo and I chose the best amongst the three. The team is approachable and provide updates on time. We get good quality learning experience at our home as per our convenient time.",
  },

  {
    reviewTitle: " Very Good Personal Tutor",
    location: "Mumbai,India",
    name: "KanchyKanz",
    image: "customer-review-2.png",
    content:
      "	Really very happy with this institution as I could get a very good personal tutor for my daughter. Prashanthini has been very good and we could see a difference within a month in our daughter's learning curve. All thanks to Prashanthini who treats our daughter as her own.",
  },
  {
    reviewTitle: " Friendly Staff",
    location: "Hyderabad,India",
    name: "Sowjanya Balireddy",
    image: "customer-review-3.png",
    content:
      "	Very good institute and friendly staff. We recently hired a shadow teacher from Home shiksha and she has very good knowledge and idea about what she need to work on based on the child needs and requirements. Based on that she stated working on it… which is really good. Thanks home shiksha.. 👍",
  },
  {
    reviewTitle: " Professional Services",
    location: "Bangalore,India",
    name: "Dassan Gita",
    image: "customer-review-4.png",
    content:
      "	I had contacted Homesiksha for shadow teacher requirement for my child, 6 years old. Ms Moumita was my contact point at Homesiksha Bangalore branch ,She was very professional and attentive to my requirements .I found Homesiksha services very professional, prompt and fuss free. Have recommended their services to my friends aswell.",
  },
  {
    reviewTitle: " Professional Approach",
    location: "Hyderabad,India",
    name: "Aniruddha Banik",
    image: "customer-review-8.png",
    content:
      " I got instant response upon my queries. They had provided very experienced and good tutor for my 12 years old son who is in CBSE board. Happy yo share that they are excellent in service commitment and have good professional approach towards the services provided. Thank you Home Shiksha for supporting parents like us who need good home tutor",
  },
  {
    reviewTitle: " Excellent Tuitions",
    location: "Bangalore,India",
    name: "Fathima",
    image: "customer-review-5.png",
    content:
      "	Homeshiksha has connected me to some excellent tuitions which take into consideration the requirements and convenience of both the students, as well as the tutors. 10/10",
  },
  {
    reviewTitle: " Best platform",
    location: "Hyderabad,India",
    name: "Sravanthivd",
    image: "customer-review-6.png",
    content:
      "	I looked for shadow teacher service..They give the options for us to choose the best for our requirement...Overall the service is good as of now.",
  },
  {
    reviewTitle: " Long Lasting Relationship",
    location: "Bangalore,India",
    name: "Rachel Poovaiah",
    image: "customer-review-9.png",
    content:
      "	Homeshiksha has been proactive in providing quality teachers in a short span of time.They have coordinated well to understand my needs. Looking forward to have a long lasting relationship with them.",
  },
  {
    reviewTitle: " Good Support",
    location: "Hyderabad,India",
    name: "Sindhuja",
    image: "customer-review-7.png",
    content:
      "	Home siksha has given me a very good support by searching a qualified teacher who Can match my requirements. They have shown enough patience. Thank you for that # it depends on the teacher though.",
  },
  {
    reviewTitle: " Response Quick",
    location: "Mumbai,India",
    name: "Sheena Mehta",
    image: "customer-review-1.png",
    content:
      "	After shifting to Mumbai and duped by so many private agencies I gave one last shot by contacting Home shiksha. Believe me they were a life saviour that time . If I can add always there to lend an ear to hear your issues. I have finally got two tutors from them and will soon be getting one more for my daughter.. Thankyou Homeshiksha.",
  },
  {
    reviewTitle: " Being So Reliable",
    location: "Hyderabad,India",
    name: "Gautham Kapoor",
    image: "customer-review-9.png",
    content:
      "	HomeShiksha is a superb platform to learn. I am doing MBA Finance with no commerce/ economics background. So Home Shiksha has been my go to place for past one year to seek great tutors who are guiding me through subjects unfamiliar to me. Thanks for being so reliable",
  },
  {
    reviewTitle: " Great platform",
    location: "Mumbai,India",
    name: "Rahul Chavan",
    image: "customer-review-10.png",
    content:
      "	Home Shiksha provides great, and useful platform in educational field. I have been grateful to them for arranging tutors, and classes as per our kids requirements.",
  },
  {
    reviewTitle: " Very Responsible",
    location: "Hyderabad,India",
    name: "Radhika Tatiyal",
    image: "customer-review-2.png",
    content:
      "	I got in touch with Home Shiksha for a teacher and the response by Divya was always prompt. She helped us find a very reliable and responsible teacher as per the requirements. Divya is soft spoken and quickly caught hold of what has to be delivered. Glad about this association. Would highly recommend Home Shiksha to anybody looking for good tutors.",
  },
  {
    reviewTitle: " Very Good Support",
    location: "Hyderabad,India",
    name: "Rajakumara M. N Raaj",
    image: "customer-review-11.png",
    content:
      "	Very good support for clients and nice result for control behaviour related issues .... They are providing very gud and supportive thepists..... 👏👏👏👏😊😊 …",
  },
  // {
  //   reviewTitle: " Skilled Shadow Teacher",
  //   location: "Bangalore,India",
  //   name: "Saroj Das",
  //   image: "tutor-review-15-m.svg",
  //   content:
  //     "	I was looking for shadow teacher and then I connect with Divya. She helped me to get very skilled shadow teacher and are also trained for special need children. I am very happy with the service so far and she also take care of my budget.",
  // },
  // {
  //   reviewTitle: " Full Satisfied",
  //   location: "Hyderabad,India",
  //   name: "Pooja Behera",
  //   image: "tutor-review-13-f.svg",
  //   content:
  //     "At first I was really scared that how would I explain my Son’s condition as he has ASD to find good teacher for him ,but I am so glad I got connected with HomeShiksha as they helped me a lot , understood the need and accordingly find the best one . Divya was in constant touch unless I am full satisfied With kind of teacher I am looking for. Thank you HomeShiksha!!",
  // },
  // {
  //   reviewTitle: " Very Effective",
  //   location: "Mumbai,India",
  //   name: "Vaishali Tongay",
  //   image: "tutor-review-14-f.svg",
  //   content:
  //     "	This platform is very good and has been playing an very important and effective role in filling the gap of supply and demand of the tutors and students. The platform and the team itself is very friendly and humble. Great platform to find tutors.",
  // },
];
